import { getFontStyles } from '@elo-kit/utils/fonts.utils'

import { COLORS } from '@elo-kit/constants/general.constants'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlack, eloBlue, eloWhite } = COLORS

// TODO: update with using createUseStyles
const lessonsListStyles = (theme) => ({
  lessonsListSection: {
    width: '100%',
    padding: '0 30px',
    '@media (max-width: 991px)': {
      padding: `0 ${theme.fullWidth ? 10 : 0}px`,
    },
  },
  title: {
    display: 'flex',
    maxWidth: '1140px',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontSize: `${theme.courseOverview.overviewTitleSize || '40'}px`,
    fontFamily: cleanupFonts(theme.courseOverview.overviewTitleFont) || 'Montserrat Medium',
    fontStyle: theme.courseOverview.overviewTitleStyle,
    fontWeight: theme.courseOverview.overviewTitleStyle,
    color: theme.courseOverview.overviewTitleColor || eloBlack,
    lineHeight: 1,
    margin: '80px auto 30px',
    '@media (max-width: 991px)': {
      marginTop: `${theme.showOverviewBanner ? '40px' : '10px'}`,
    },
  },
  lessonsContainer: {
    maxWidth: '1140px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: '0 auto',
  },
  lessonWidgetContainer: {
    width: '270px',
    height: 'calc(100% - 390px)',
    boxShadow: '0 6px 20px 0 #00000026',
    margin: '0 20px 60px',
    borderRadius: '6px',
  },
  lessonDetails: {
    padding: '20px 30px 30px',
    borderBottomRightRadius: 6,
    borderBottomLeftRadius: 6,
    backgroundColor: theme.courseOverview.overviewItemsBackground || eloWhite,
  },
  lessonTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    fontSize: `${theme.courseOverview.overviewItemsSize || '18'}px`,
    fontFamily: cleanupFonts(theme.courseOverview.overviewItemsFont) || 'Montserrat Medium',
    fontStyle: theme.courseOverview.overviewItemsStyle,
    fontWeight: theme.courseOverview.overviewItemsStyle,
    color: theme.courseOverview.overviewItemsColor || eloBlack,
    overflow: 'hidden',
    wordBreak: 'break-word',
    minHeight: '50px',
    textAlign: 'center',
  },
  noCoverContainer: {
    fontSize: '100px',
    color: eloWhite,
  },
  button: {
    width: '100%',
    minHeight: '43px',
    borderRadius: '4px',
    backgroundColor: theme.buttonColor || eloBlue,
    fontSize: `${theme.buttonSize || 15}px`,
    fontFamily: cleanupFonts(theme.buttonFont) || 'Montserrat Medium',
    ...getFontStyles(theme.buttonStyle),
    color: theme.buttonFontColor || eloWhite,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
    '&:active': {
      opacity: 0.6,
    },
  },
})

export default lessonsListStyles
